import { ENewPasswordNonEligibleReasonType } from "@/types/backoffice/dto/subscriber/subscriber-new-password-dto.ts";

const toastLocale = {
  toast: {
    photos: {
      upload: {
        success: "Les photos ont été uploadés",
        error: "Une erreur est survenue lors de l'upload d'une ou plusieurs photos",
      },
    },
    signature: {
      reminder: {
        success: "Demande de signature renvoyée",
        error: "Une erreur est survenue lors de l'envoi de la demande de signature",
      },
      validateEsc: {
        success: "Dossier CEE validé",
        error: "Une erreur est survenue lors de la validation du dossier CEE",
      },
      resendBankingInformationToken: {
        success: "Demande de récupération d'IBAN renvoyée",
        error: "Une erreur est survenue lors de l'envoi de la demande de récupération d'IBAN",
      },
      upgradeToEsc: {
        success: "Nouvelle signature pour CEE générée",
        error: "Une erreur est survenue lors de la génération la signature CEE",
      },
      cancel: {
        success: "Demande de signature annulée",
        error: "Une erreur est survenue lors de l'annulation de la demande de signature",
      },
      regenerate: {
        success: "Demande de signature régénérée",
        error: "Une erreur est survenue lors de la régénération de la demande de signature",
      },
      customerServiceCertificate: {
        success: "Attestation de SAV envoyée",
        error: "Une erreur est survenue lors de l'envoi de l'attestation de SAV",
      },
    },
    esc: {
      nonEligiblityCriteria: {
        success: "Les critères d'éligibilité ont été mis à jour",
        error: "Une erreur est survenue lors de la mise à jour des critères d'éligibilité",
      },
    },
    copy: {
      error: {
        notSupported: "Impossible d'utiliser le presse-papier (permission manquante)",
      },
      success: "La valeur du champ a été copiée dans le presse-papier",
    },
    login: {
      error: "Nom d'utilisateur et/ou mot de passe incorrect",
      sessionExpired: "Votre session a expiré. Vous allez être redirigé vers la page de connexion.",
      noApplicationRights: "Vous n'avez pas les droits nécessaires pour accéder à cette application.",
    },
    comfort: {
      cancel: {
        success: "Personnalisation correctement annulée",
        error: "Une erreur est survenue lors de l'annulation de la personnalisation",
      },
      apply: {
        success: "Personnalisation correctement appliquée",
        error: "Une erreur est survenue lors de l'application de la personnalisation",
      },
    },
    site: {
      heatPumpDeclarations: {
        edit: {
          success: "La PAC a bien été rattachée au site",
          error: "Une erreur est survenue lors du rattachement au site",
        },
      },
      closeCall: {
        error: "Une erreur est survenue lors de la fermeture du dossier",
      },
      attachSubscriber: {
        success: "L'adhérent a bien été rattaché au site",
        error: "Une erreur est survenue lors du rattachement au site",
      },
      access: {
        error: "Une erreur est survenue lors du chargement du site, merci de réessayer ultérieurement",
      },
    },
    deliveryPoint: {
      manualUpdate: {
        success: "PDL correctement mis à jour",
        error: "Erreur lors de la mise à jour du PDL",
        // Braced linked key: a bare `@:key:` would swallow the trailing colon into the key name
        reasons: {
          blankPdl: "@:{'toast.deliveryPoint.manualUpdate.error'} : le PDL est obligatoire",
          invalidEnedisPdlSize:
            "@:{'toast.deliveryPoint.manualUpdate.error'} : le site dépend du GRD Enedis, dont les PDL comptent exactement 14 caractères",
          invalidEnedisControlKey:
            "@:{'toast.deliveryPoint.manualUpdate.error'} : le site dépend du GRD Enedis, et la clé de contrôle du PDL (2 derniers caractères) ne correspond pas",
          invalidFlowForEnedisDso:
            "@:{'toast.deliveryPoint.manualUpdate.error'} : le compteur est géré par Enedis : ce PDL ne peut pas être saisi manuellement sur un site hors de France",
          invalidState:
            "@:{'toast.deliveryPoint.manualUpdate.error'} : la saisie manuelle est impossible sur un site organisation ou équipé de plusieurs compteurs",
        },
      },
      searchUpdate: {
        success: "PDL correctement mis à jour",
        error: "Erreur lors de la mise à jour du PDL",
        searchError: "Erreur lors de la recherche des PDL",
        _20003: "Trop de résultats",
      },
    },
    subscriber: {
      create: {
        error: "Error while submitting subscriber's creation, please try again later!",
      },
      setPrivileged: {
        success: "L'adhérent fait parti du PSB",
        error: "Une erreur est survenue, merci de réessayer ultérieurement",
      },
      sendAgreementLetter: {
        success: "Mail d'accord envoyé",
        error: "Une erreur est survenue, merci de réessayer ultérieurement",
      },
      transferSignature: {
        success: "Signature Yousign ouverte",
        error: "Une erreur est survenue lors de la demande de signature",
        cancelSuccess: "Signature Yousign annulée",
        cancelError: "Une erreur est survenue lors de l'annulation",
      },
      unsetPrivileged: {
        success: "L'adhérent ne fait plus parti du PSB",
        error: "Une erreur est survenue, merci de réessayer ultérieurement",
      },
      unsetVip: {
        success: "L’abonné n'est plus VIP",
        error: "Une erreur est survenue, veuillez réessayer plus tard !",
      },
      setVip: {
        success: "L’abonné est désormais VIP",
        error: "Une erreur est survenue, veuillez réessayer plus tard !",
      },
      edit: {
        success: "L'adhérent à été mis à jour",
        error: "Une erreur est survenue lors de la mise à jour de l'adhérent, merci de réessayer ultérieurement",
      },
      rotation: {
        success: "La déclaration de déménagement de l'adhérent à été enregistré",
        error: "Une erreur est survenue lors de la déclaration du déménagement, merci de réessayer ultérieurement",
      },
      resetPassword: {
        success: "Mot de passe réinitialisé",
        nonEligibleOnboardedMyV2016:
          "L'utilisateur n'est pas éligible à MyVoltalis V2 et a été onboardé sur MyVoltalis V1 car: ",
        nonEligibleNotOnboardedMyV2016: "L'utilisateur n'est pas éligible à MyVoltalis V2 car: ",
        nonEligible: {
          [ENewPasswordNonEligibleReasonType.PARTNER_IS_EKWATEUR]: "L'utilisateur est un client Ekwateur",
          [ENewPasswordNonEligibleReasonType.NO_APPLIANCE_INSTALLED]:
            "Il n'y a aucun chauffage / climatisation sur le site",
          [ENewPasswordNonEligibleReasonType.MULTISITE]: "L'utilisateur possède plusieurs sites",
          [ENewPasswordNonEligibleReasonType.NO_INSTALLATION_DATE]:
            "Le site de l'utilisateur n'a pas encore été équipé (pas de date d'installation renseignée)",
          [ENewPasswordNonEligibleReasonType.INSTALLATION_DATE_IS_TOO_OLD]:
            "Le site a été installé il y a trop longtemps (avant 01/06/2022)",
          [ENewPasswordNonEligibleReasonType.TOO_MANY_APPLIANCES]:
            "Le site possède plus de 20 chauffages / climatisations",
          [ENewPasswordNonEligibleReasonType.TERTIARY_SITE]: "Le site appartient à un tertiaire",
          [ENewPasswordNonEligibleReasonType.UNKNOWN]: "Raison inconnue",
        },
        error: "Une erreur est survenue lors de l'envoie du mot de passe, merci de réessayer ultérieurement",
      },
    },
    subscription: {
      create: {
        success: "L'adhésion a bien été créée",
        error: "Une erreur est survenue lors de la création de l'adhésion, merci de réessayer ultérieurement",
      },
      addTag: {
        success: "Le tag a bien été ajouté à l'adhésion",
        error: "Une erreur est survenue lors de l'ajout du tag, merci de réessayer ultérieurement",
      },
      removeTag: {
        success: "Le tag a bien été retiré de l'adhésion",
        error: "Une erreur est survenue lors de la suppression du tag, merci de réessayer ultérieurement",
      },
      reOpen: {
        success: "L'adhésion a bien été ré-ouverte",
        error: "Une erreur est survenue lors de la ré-ouverture de l'adhésion, merci de réessayer ultérieurement",
      },
    },
    operation: {
      edit: {
        success: "L'opération été mis à jour",
        error: "Une erreur est survenue lors de la mise à jour de l'opération, merci de réessayer ultérieurement",
        warn: "Aucune valeur n'a été changée, pas de mise à jour nécessaire",
      },
    },
    sensor: {
      sendSensor: {
        success: "La demande d'envoie des capteurs à été enregistré",
        error: "Une erreur est survenue lors de la demande d'envoie des capteurs, merci de réessayer ultérieurement",
      },
    },
    gatewayShipment: {
      request: {
        success: "La demande d'envoi de pilote a été enregistrée",
        error: "Une erreur est survenue lors de la demande d'envoi de pilote, merci de réessayer ultérieurement",
      },
    },
    autoDiag: {
      refreshMyV: {
        success: "Programmation MyV synchronisée",
        error: "Une erreur est survenue lors de la synchronisation, merci de réessayer ultérieurement",
      },
    },
    support: {
      success: "Demande de support envoyée",
      error: "Une erreur est survenue lors de la demande de support, merci de réessayer ultérieurement",
      abuse: {
        success: "Signalement transmis",
        error: "Une erreur est survenue lors de la transmission du signalement, merci de réessayer ultérieurement",
      },
      satisfactionSurvey: {
        success: "Enquête de satisfaction envoyée",
        error: "Une erreur est survenue lors de l'envoie de l'enquête, merci de réessayer ultérieurement",
      },
    },
    reintervention: {
      edit: {
        success: "Consignes de réintervention mis à jour",
        error:
          "Une erreur est survenue lors de la mise à jour des consignes de réintervention, merci de réessayer ultérieurement",
      },
    },
  },
};

export type ToastLocale = typeof toastLocale;
export default toastLocale;
